// Extraído do spine (dp-loc, Wave-B): normaliza os tool_calls crus do provider
// pro shape interno do loop. Comportamento byte-idêntico ao bloco inline que
// substitui (characterization tests do loop seguem verdes).

import { parseToolArgs } from '../toolArgs.js';

/** @param {any} reply @param {number} iteration */
export function normalizeLoopToolCalls(reply, iteration) {
  return (Array.isArray(reply?.tool_calls) ? reply.tool_calls : []).map((tc, i) => ({
    id: tc.id || `call_${iteration}_${i}`,
    name: tc.name || tc.function?.name || 'tool',
    arguments: parseToolArgs(tc.arguments ?? tc.function?.arguments),
    // E1-WS3 — preserva a flag "args truncados/não-parseáveis" do backend pro
    // exec loop sinalizar em vez de rodar com args fantasmas vazios.
    ...(tc.__argsError ? { __argsError: tc.__argsError } : {}),
  }));
}
